// Some common vars that won't change across scripts
const body = document.getElementsByTagName("body")[0]
const headerContainer = document.querySelector('.header-container')
const header =  document.querySelector('.main-header')
const adminRegion = document.querySelector('.admin-region')

// Declare our helperFunctions here so that we can reuse them more easily
const helperFunctions = {

  // Limit a number between a custom range
  limitNumberWithinRange: function (num, min, max){
    const MIN = min || 1,
          MAX = max || 10,
          parsed = parseInt(num);

    return Math.min(Math.max(parsed, MIN), MAX)
  },

  // Loops through parents to find distance from top of document for an element
  getDistanceFromTop: function (element) {
    let distance = 0;

    // Loop up the DOM
    // Is this the best way? I couldn't find a better way :/
    if (element.offsetParent) {
      do {
        distance += element.offsetTop;
        element = element.offsetParent;
      } while (element);
    }
    return distance < 0 ? 0 : distance;
  }
}


console.log(`This website is made by %cAgile Collective`, "color: #F35C49; font-family: 'Apercu', 'Apercu Pro', 'Mukta', aria, sans-serif; background: #23334B; padding: 12px; font-size: 22px;")
console.log('https://www.agile.coop/');


/*
OS detection....
If you are on Mac OS X 10.0-10.12 then you have a bug in Firefox where variable fonts don't render properly
This code checks the user agent string for the OS version and removed a class from body, it's as close as we can easily get
It applies gracefully to firefox only due to the regex and checks at various points for specific numbers and versions
*/
(function(){
  let userAgent = navigator.userAgent.toLowerCase()
  let stringReg = new RegExp('(mac os x 10)+(\\.)+\\b\\d{1,2}\\b')
  let versionReg = new RegExp('\\b\\d{1,2}\\b$')

  let match = stringReg.test(userAgent)

  if (match) {
    let osVersion = stringReg.exec(userAgent)
    osVersion = osVersion[0]

    let versionNumber = versionReg.exec(osVersion)
    versionNumber = versionNumber[0]

    if (versionNumber >= 0 && versionNumber < 13) {
      body.classList.remove('variable-font')
    }
  }
})();

